import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "header",
  class: "container"
}
const _hoisted_2 = { class: "col col-lg-6" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col col-lg-6 mt-5 mt-lg-0" }
const _hoisted_5 = {
  key: 0,
  class: "text-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-5 fw-bold" }, "Recent Updates", -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 col-md" }
const _hoisted_9 = { class: "fw-semibold mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold mb-3" }, "Food Donation Count", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", { class: "opacity-75" }, " This count shows the number of confirmed transactions made by Food Donors through out the week. ", -1)
const _hoisted_12 = { class: "col-12 col-md mt-5 mt-md-0" }
const _hoisted_13 = { class: "fw-semibold mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-semibold mb-3" }, "Successful Transactions Count", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("small", { class: "opacity-75" }, " This count shows the number of confirmed transactions of Charity Organizations through out the week. ", -1)
const _hoisted_16 = {
  key: 1,
  class: "text-start"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-3 fw-semibold" }, "Your Statistics", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-justify" }, " Et has minim elitr intellegat. Mea aeterno eleifend antiopam ad, nam no suscipit quaerendum. At nam minimum ponderum. Est audiam animal molestiae te. Ex duo eripuit mentitum. ", -1)
const _hoisted_19 = { class: "dropdown-center" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-lg btn-dark dropdown-toggle my-3 p-3 rounded-0",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("em", { class: "bi bi-download me-3" }),
  /*#__PURE__*/_createTextVNode("Export ")
], -1)
const _hoisted_21 = { class: "dropdown-menu" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-filetype-csv me-2" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-filetype-xlsx me-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalVolume = _resolveComponent("TotalVolume")!
  const _component_DonationCount = _resolveComponent("DonationCount")!
  const _component_TransactionSuccessRates = _resolveComponent("TransactionSuccessRates")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["container-fluid", _ctx.role === 'Administrator' ? 'bg-header' : 'bg-primary'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["row flex-column flex-lg-row align-items-center py-5", _ctx.role === 'Administrator' ? 'text-white' : 'text-black'])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "img-fluid",
              src: 
              require(`@/assets/images/Statistics/${
                _ctx.role === 'Administrator' ? 'Admin_' : ''
              }Header.svg`)
            
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.role === 'Administrator')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.donationsCount), 1),
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.successfulTransactionsCount), 1),
                      _hoisted_14,
                      _hoisted_15
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("ul", _hoisted_21, [
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "dropdown-item",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportAsCSV && _ctx.exportAsCSV(...args)))
                        }, [
                          _hoisted_22,
                          _createTextVNode("CSV ")
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "dropdown-item",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.exportAsExcel && _ctx.exportAsExcel(...args)))
                        }, [
                          _hoisted_23,
                          _createTextVNode("Excel ")
                        ])
                      ])
                    ])
                  ])
                ]))
          ])
        ], 2)
      ])
    ], 2),
    _createVNode(_component_TotalVolume, {
      role: _ctx.role,
      basis: _ctx.basis,
      totalSurplusVolume: _ctx.totalSurplusVolume,
      commonFoodType: _ctx.commonFoodType,
      successRate: _ctx.successRate,
      chartData: _ctx.foodSurplusVolumeChartData,
      onUpdateBasis: _cache[2] || (_cache[2] = (basis) => (this.basis = basis))
    }, null, 8, ["role", "basis", "totalSurplusVolume", "commonFoodType", "successRate", "chartData"]),
    _createVNode(_component_DonationCount, {
      role: _ctx.role,
      governmentLevel: _ctx.governmentLevel,
      chartData: _ctx.donationCountChartData,
      onUpdateGovernmentLevel: _cache[3] || (_cache[3] = (level) => (this.governmentLevel = level))
    }, null, 8, ["role", "governmentLevel", "chartData"]),
    _createVNode(_component_TransactionSuccessRates, {
      role: _ctx.role,
      chartData: _ctx.successRatesChartData
    }, null, 8, ["role", "chartData"])
  ], 64))
}